import { TeamInLeague, Player, Position, GameConfig } from "../domain/entities";
import { PlayerGenerator } from "./playerGenerator";

export const refreshYouthSquad = (team: TeamInLeague, leagueName: string, config: GameConfig, currentWeek: number): void => {
    // Add a news item for the player's team
    if (!team.name.includes(" (CPU)")) { // Assuming player team doesn't have CPU marker
        // This check should be based on gameState.playerTeamName, but this service doesn't have it.
        // The caller in GameService will handle adding the news item.
    }

    // Calculate preference effectiveness based on time since preferences were set
    // Preferences diminish as they get closer to next intake
    let preferenceEffectiveness = 1.0;
    if (team.youthAcademy.preferences?.preferencesSetWeek !== undefined) {
        // Next intake week is the next multiple of 4
        const nextIntakeWeek = Math.ceil(currentWeek / 4) * 4;
        const weeksUntilIntake = Math.max(1, nextIntakeWeek - currentWeek);
        // Effectiveness: 4 weeks away = 100%, 3 weeks = 75%, 2 weeks = 50%, 1 week = 25%
        preferenceEffectiveness = weeksUntilIntake / 4;
    }

    const newYouths: Player[] = [];

    // Ensure at least 2 players for each position
    const requiredPositions: Position[] = ['GK', 'GK', 'DEF', 'DEF', 'MID', 'MID', 'FWD', 'FWD'];
    requiredPositions.forEach(pos => {
        newYouths.push(PlayerGenerator.generateYouthPlayer(team, pos, leagueName, config, team.youthAcademy.preferences, preferenceEffectiveness));
    });

    // Add more players based on academy level (reduced generation rate)
    // Level 1: 0 additional, Level 2: 1 additional, Level 3: 2 additional, Level 4: 2 additional
    const additionalPlayersCount = Math.max(0, Math.floor((team.youthAcademy.level - 1) / 1.5));
    const allPositions: Position[] = ['GK', 'DEF', 'MID', 'FWD'];

    for (let i = 0; i < additionalPlayersCount; i++) {
        const randomPos = allPositions[Math.floor(Math.random() * allPositions.length)];
        newYouths.push(PlayerGenerator.generateYouthPlayer(team, randomPos, leagueName, config, team.youthAcademy.preferences, preferenceEffectiveness));
    }

    // Replace old youth squad with the new intake
    team.youthAcademy.squad = newYouths;
};